import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

interface UserState {
  currentUser: any | null;
}

const initialState: UserState = {
  currentUser: null,
};

const userSlice = createSlice({
  name: "user",

  initialState,

  reducers: {
    setUser: (
      state,
      action: PayloadAction<any>,
    ) => {
      state.currentUser =
        action.payload;
    },

    clearUser: (state) => {
      state.currentUser = null;
    },

  },
});

export const {
  setUser,
  clearUser,
} = userSlice.actions;

export default userSlice.reducer;
